import { globalSystemConstants } from "../../constants";
import { dashboardConstants } from "../../constants/dashboard.constants";
import { ToastifyService, userService } from "../../services";
import { custom, success } from "./utilities";

const getDashboardData = (systemUserId, pageSize) => {
    return (dispatch) => {
      dispatch(
        custom(dashboardConstants.DASHBOARD_DATA, globalSystemConstants.SPINNER_ACTIVATE)
      );
      userService
        .getDashoboardData(systemUserId, pageSize)
        .then((response) => {       
            dispatch(
                success(response, dashboardConstants.DASHBOARD_DATA)
              );
        })
        .catch((error) => {
          ToastifyService.showError(error);
        }).finally(() => {
          dispatch(
            custom(dashboardConstants.DASHBOARD_DATA, globalSystemConstants.SPINNER_DEACTIVATE)
          );
        });
    };
  };

const getUserRecommendationsData = (systemUserId, params) => {
    return (dispatch) => {
      userService
        .getUserRecommendationsData(systemUserId, params)
        .then((response) => {
            dispatch(
                success(response, dashboardConstants.RECOMMENDATIONAN_DATA)
              );
        })
        .catch((error) => {
          ToastifyService.showError(error);
        });
    };
  };

  export const DashboardActions = {
    getDashboardData,
    getUserRecommendationsData
  };